import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';

import { PaymentTerm, PaymentTermService, PaymentTermsDataService } from '@lib/payment-terms';
import { NotificationMessageLevel, NotificationService } from '@lib/core';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { DemandPaymentTermDataService } from './demand-payment-term-data.service';
import { MatIconButton } from '@angular/material/button';
import { RequiredUtilsModule } from '@lib/util';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'demand-supplier-payment-term',
    imports: [MatIconButton, RequiredUtilsModule, TranslateModule, MatTooltip],
    templateUrl: './demand-supplier-payment-term.component.html',
    styleUrl: './demand-supplier-payment-term.component.scss'
})
export class DemandSupplierPaymentTermComponent implements OnInit {
    private readonly paymentTermsDataService = inject(PaymentTermsDataService);
    private readonly demandPaymentTermDataService = inject(DemandPaymentTermDataService);
    private readonly paymentTermService = inject(PaymentTermService);
    private readonly notificationService = inject(NotificationService);

    @Input() public paymentTerm?: PaymentTerm;
    @Input({ required: true }) public paymentTermRequired!: boolean;
    @Input({ required: true }) public supplierCompanyId!: string;
    @Input() public companyCodeId?: string | null;
    @Input({ required: true }) public demandId!: string;
    @Input() public editable = false;

    @Output() deleted = new EventEmitter<void>();
    @Output() updated = new EventEmitter<PaymentTerm>();

    public paymentTermOptions?: PaymentTerm[];

    ngOnInit(): void {
        this.getOptions();
    }

    public openPaymentTermSelection(): void {
        this.paymentTermService
            .selectPaymentTerm(this.supplierCompanyId, this.editable, this.paymentTermOptions!)
            .subscribe((result: PaymentTerm | void) => {
                if (result) {
                    this.update(result);
                }
            });
    }

    public deleteCurrent($event: Event): void {
        $event.stopPropagation();
        if (this.editable && this.paymentTerm) {
            this.demandPaymentTermDataService.deletePaymentTerm(this.demandId, this.supplierCompanyId).subscribe(() => {
                const message = marker('Zahlungsbedingung entfernt');
                this.notificationService.showNotification(message, NotificationMessageLevel.SUCCESS);
                this.paymentTerm = undefined;
            });
            this.deleted.emit();
        }
    }

    public update(newPaymentTerm: PaymentTerm): void {
        if (this.editable) {
            this.demandPaymentTermDataService
                .updatePaymentTerm(this.demandId, this.supplierCompanyId, newPaymentTerm.id)
                .subscribe(() => {
                    const message = marker('Zahlungsbedingung gespeichert');
                    this.notificationService.showNotification(message, NotificationMessageLevel.SUCCESS);
                    this.paymentTerm = newPaymentTerm;
                });
            this.updated.emit(newPaymentTerm);
        }
    }

    public displayPaymentTerm(): boolean {
        return (this.editable || !!this.paymentTerm) && !!this.paymentTermOptions && !!this.paymentTermOptions.length;
    }

    private getOptions(): void {
        if (!this.paymentTermOptions) {
            this.paymentTermsDataService
                .getAllPaymentTerms(this.supplierCompanyId, this.companyCodeId)
                .subscribe((paymentTerms: PaymentTerm[]) => {
                    this.paymentTermOptions = paymentTerms;
                });
        }
    }
}
